<template>
  <section class="regulamin">
    <h1>Regulamin sklepu internetowego</h1>

    <div class="regulamin-blok">
      <h2>1. Informacje ogólne</h2>
      <p>Sklep internetowy prowadzony jest przez firmę BIRDSOFT sp. z o.o. z siedzibą przy ul. Kaliska 35A/210, 63-400 Ostrów Wielkopolski, Polska. NIP: PL6222856070. Regulamin określa zasady korzystania ze sklepu, składania zamówień, płatności, wysyłki oraz zwrotów.</p>

      <h2>2. Składanie zamówień</h2>
      <p>Zamówienia można składać 24/7 poprzez stronę internetową. Do złożenia zamówienia nie jest wymagane zakładanie konta.</p>

      <h2>3. Płatność</h2>
      <p>Dostępne formy płatności to:</p>
      <ul>
        <li>płatność online (szybkie przelewy, BLIK, karta płatnicza),</li>
        <li>płatność za pobraniem (przy odbiorze przesyłki),</li>
        <li>płatność za pośrednictwem systemu PayPal.</li>
      </ul>

      <h2>4. Dostawa</h2>
      <p>Wysyłka realizowana jest na terenie Polski i krajów Unii Europejskiej. Dostawa odbywa się za pośrednictwem firm kurierskich, zgodnie z informacją przy zamówieniu. Czas realizacji zamówienia wynosi do 10 dni roboczych.</p>

      <h2>5. Zwroty</h2>
      <p>Konsument ma prawo odstąpić od umowy w terminie 14 dni od otrzymania przesyłki, bez podania przyczyny. Produkt nie może nosić śladów użytkowania. Koszt odesłania towaru pokrywa kupujący.</p>

      <h2>6. Reklamacje</h2>
      <p>W przypadku otrzymania towaru uszkodzonego lub niezgodnego z zamówieniem, prosimy o kontakt mailowy. Reklamacje rozpatrywane są w ciągu 14 dni roboczych.</p>

      <h2>7. Ochrona danych osobowych</h2>
      <p>Dane osobowe są przetwarzane zgodnie z obowiązującymi przepisami RODO. Administrator danych to BIRDSOFT sp. z o.o. Dane są wykorzystywane wyłącznie w celu realizacji zamówienia.</p>

      <h2>8. Postanowienia końcowe</h2>
      <p>Regulamin obowiązuje od momentu opublikowania na stronie sklepu. Sklep zastrzega sobie prawo do zmian regulaminu – zmiany nie wpływają na zamówienia złożone przed ich wejściem w życie.</p>
    </div>
  </section>
</template>

